let shareModal = () => {
    let obj = document.getElementById('jsShareModal')
    $('.js-share-modal').map((index, value) => {
        $(value).on('click', () => {
            let host = `https://${window.location.host}${window.location.pathname}`
            obj.dataset.a2aUrl = `${host}?type=trailer&num=${++index}`
            obj.dataset.a2aTitle = document.title
        })
    })
  
  let pcSlideShare = document.getElementById('pcSlideShare')
  pcSlideShare.querySelector('.ziDingYi_style').dataset.a2aUrl = `https://${window.location.host}${window.location.pathname}`
  
}

export default shareModal